import axios from "axios";
import Config from "../../../config";

const v2_actionConfigCrm = (clienteId, querys) => {
    
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/crm-config${querys ? querys : ''}`
    });
};

export default v2_actionConfigCrm;
